import { render } from "./FeedbackPopupTextValue.vue?vue&type=template&id=36e72b8d&scoped=true"
import script from "./FeedbackPopupTextValue.vue?vue&type=script&lang=js"
export * from "./FeedbackPopupTextValue.vue?vue&type=script&lang=js"

import "./FeedbackPopupTextValue.vue?vue&type=style&index=0&id=36e72b8d&scoped=true&lang=scss"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e72b8d"],['__file',"src/components/FeedbackPopupTextValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36e72b8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36e72b8d', __exports__)) {
    console.log('reload')
    api.reload('36e72b8d', __exports__)
  }
  
  module.hot.accept("./FeedbackPopupTextValue.vue?vue&type=template&id=36e72b8d&scoped=true", () => {
    console.log('re-render')
    api.rerender('36e72b8d', render)
  })

}


export default __exports__